var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoader = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 56,
  fill: "#212431",
  viewBox: "0 0 56 56"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M29.75 42v9.33c0 .97-.78 1.75-1.75 1.75s-1.75-.78-1.75-1.75V42c0-.97.78-1.75 1.75-1.75s1.75.78 1.75 1.75m9.38-5.34c-.68-.68-1.79-.68-2.47 0s-.68 1.79 0 2.47l6.6 6.6c.34.34.79.51 1.24.51s.9-.17 1.24-.51c.68-.68.68-1.79 0-2.47l-6.6-6.6Zm-22.26 0-6.6 6.6a1.75 1.75 0 0 0 0 2.47c.34.34.79.51 1.24.51s.9-.17 1.24-.51l6.6-6.6c.68-.68.68-1.79 0-2.47s-1.79-.68-2.47 0Zm34.46-10.41H42c-.97 0-1.75.78-1.75 1.75s.78 1.75 1.75 1.75h9.33c.97 0 1.75-.78 1.75-1.75s-.78-1.75-1.75-1.75M15.75 28c0-.97-.78-1.75-1.75-1.75H4.67c-.97 0-1.75.78-1.75 1.75s.78 1.75 1.75 1.75H14c.97 0 1.75-.78 1.75-1.75m22.14-8.14c.45 0 .9-.17 1.24-.51l6.6-6.6c.68-.68.68-1.79 0-2.47a1.75 1.75 0 0 0-2.47 0l-6.6 6.6a1.75 1.75 0 0 0 0 2.47c.34.34.79.51 1.24.51Zm-25.15-9.59a1.75 1.75 0 0 0-2.47 0 1.75 1.75 0 0 0 0 2.47l6.6 6.6c.34.34.79.51 1.24.51s.9-.17 1.24-.51c.68-.68.68-1.79 0-2.47l-6.6-6.6ZM28 2.92c-.97 0-1.75.78-1.75 1.75V14c0 .97.78 1.75 1.75 1.75s1.75-.78 1.75-1.75V4.67c0-.97-.78-1.75-1.75-1.75"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  begin: "0s",
  calcMode: "linear",
  dur: "2s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "rotate",
  values: "0 28 28;360 28 28"
}))));
export default SvgLoader;